import {FC, useContext, useRef} from 'react'
import dayjs from 'dayjs'
import {useIntl} from 'react-intl'
import {Booking} from '../../../modules/apps/booking/list/core/_models'
import {useAuth} from '../../../modules/auth'
import {calculateDuration} from '../../../../_component/CustomFunctions'
import {KTSVG} from '../../../../_metronic/helpers'
import {StaticRating} from '../../../../_component/Rating'
import {GetDuration} from '../../../../_component/CustomComponent'
import {BookingContext} from '../Page'
type Props = {
  booking: Booking
}

const FetchModalPage: FC<Props> = ({booking}) => {
  const intl = useIntl()
  const {business} = useAuth()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const {hour, min} = calculateDuration(booking.service?.duration)
  const {currentUser} = useAuth()
  const {setReviewShow} = useContext(BookingContext)
  return (
    <>
      {/* file:///Users/tony/Downloads/metronic_v8.1.1/html/demo1/dist/apps/subscriptions/view.html */}
      <div className='card card-flush mb-5 mb-xl-10'>
        {/*begin::Card body*/}
        <div className='card-body pt-3'>
          {/*begin::Section*/}
          <div className='mb-10'>
            {/*begin::Title*/}
            <h5 className='mb-4'>{intl.formatMessage({id: 'Booking'})} Details:</h5>
            {/*end::Title*/}
            {/*begin::Details*/}
            <div className='d-flex flex-wrap py-5'>
              {/*begin::Row*/}
              <div className='flex-equal me-5'>
                {/*begin::Details*/}
                <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                  {/*begin::Row*/}
                  <tbody>
                    <tr>
                      <td className='text-gray-400'>{intl.formatMessage({id: 'Location'})}:</td>
                      <td className='text-gray-800'>{booking.location?.name}</td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>Address:</td>
                      <td className='text-gray-800'>{booking.location?.address1}</td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>City:</td>
                      <td className='text-gray-800'>{booking.location?.city}</td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>State:</td>
                      <td className='text-gray-800'>{booking.location?.state}</td>
                    </tr>
                  </tbody>
                  {/*end::Row*/}
                </table>
                {/*end::Details*/}
              </div>
              {/*end::Row*/}
              {/*begin::Row*/}
              <div className='flex-equal'>
                {/*begin::Details*/}
                <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                  <tbody>
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>{intl.formatMessage({id: 'Service'})}:</td>
                      <td className='text-gray-800'>{booking.service?.name}</td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>Duration:</td>
                      <td className='text-gray-800'>
                        {hour ? hour + 'hrs' : ''} {min ? min + 'mins' : ''}
                      </td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>Phone Number:</td>
                      <td className='text-gray-800'>{booking.location?.phone_number}</td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>Email Address:</td>
                      <td className='text-gray-800'>{booking.location?.email}</td>
                    </tr>
                    {/*end::Row*/}
                  </tbody>
                </table>
                {/*end::Details*/}
              </div>
              {/*end::Row*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Section*/}
          {/*begin::Section*/}
          <div className='mb-10'>
            {/*begin::Details*/}
            <div className='d-flex flex-wrap py-5'>
              {/*begin::Row*/}
              <div className='flex-equal me-5'>
                {/*begin::Title*/}
                <h5 className='mb-4'>Schedule:</h5>
                {/*end::Title*/}
                {/*begin::Details*/}
                <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                  <tbody>
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>
                        <span className='menu-icon'>
                          <KTSVG
                            path={'/media/icons/duotune/general/gen014.svg'}
                            className='svg-icon-2'
                          />
                        </span>
                        Date:
                      </td>
                      <td className='text-gray-800'>
                        {dayjs(booking.date).format('MMM DD, YYYY')}
                      </td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>
                        <KTSVG
                          path={'/media/icons/duotune/general/gen013.svg'}
                          className='svg-icon-2'
                        />
                        Start Time:
                      </td>
                      <td className='text-gray-800'>
                        {dayjs(booking.start_time).format('hh:mm A')}
                      </td>
                    </tr>
                    {/*end::Row*/}
                    {/*begin::Row*/}
                    <tr>
                      <td className='text-gray-400'>
                        <KTSVG
                          path={'/media/icons/duotune/general/gen013.svg'}
                          className='svg-icon-2'
                        />
                        End Time:
                      </td>
                      <td className='text-gray-800'>{dayjs(booking.end_time).format('hh:mm A')}</td>
                    </tr>
                    {/*end::Row*/}
                  </tbody>
                </table>
                {/*end::Details*/}
              </div>
              {/*end::Row*/}
              {/*begin::Row*/}
              <div className='flex-equal me-5'>
                {booking.completed && (
                  <>
                    {/*begin::Title*/}
                    <h5 className='mb-4'>Review:</h5>
                    {/*end::Title*/}
                    {/*begin::Details*/}
                    <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                      <tbody>
                        {/*begin::Row*/}
                        <tr>
                          <td className='text-gray-400'>Customer Review:</td>
                          <td className='text-gray-800'>
                            {booking.reviews?.find((item) => item.type === 'customer')?.review ||
                              (booking.created_by === currentUser?.account_id ? (
                                <button
                                  type='button'
                                  ref={buttonRef}
                                  onClick={() => setReviewShow(true)}
                                  className='btn btn-light btn-light-success btn-sm'
                                >
                                  <span className='indicator-label'>Write a Review</span>
                                </button>
                              ) : (
                                ''
                              ))}
                          </td>
                        </tr>
                        {/*end::Row*/}
                        {/*begin::Row*/}
                        <tr>
                          <td className='text-gray-400'>Rating:</td>
                          <td className='text-gray-800'>
                            {booking.reviews?.find((item) => item.type === 'customer')?.rating && (
                              <StaticRating
                                value={
                                  booking.reviews?.find((item) => item.type === 'customer')
                                    ?.rating || 0
                                }
                              />
                            )}
                          </td>
                        </tr>
                        {/*end::Row*/}
                      </tbody>
                    </table>
                    {/*end::Details*/}
                  </>
                )}
              </div>
              {/*end::Row*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Section*/}
          {/*begin::Section*/}
          <div className='mb-0'>
            {/*begin::Title*/}
            <h5 className='mb-4'>Attending Staff:</h5>
            {/*end::Title*/}
            {/*begin::Product table*/}
            <div className='table-responsive'>
              {/*begin::Table*/}
              <table className='table align-middle table-row-dashed fs-6 gy-4 mb-0'>
                {/*begin::Table head*/}
                <thead>
                  {/*begin::Table row*/}
                  <tr className='border-bottom border-gray-200 text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0'>
                    <th>Name</th>
                    <th>Email</th>
                    {business?.ENABLE_CLOCKING === 'True' && <th>Time Entry</th>}
                    <th className='text-end min-w-70px'>Actions</th>
                  </tr>
                  {/*end::Table row*/}
                </thead>
                {/*end::Table head*/}
                {/*begin::Table body*/}
                <tbody className='fw-semibold text-gray-800'>
                  {booking.timesheets?.map((t, i) => {
                    let diff = null
                    if (business?.ENABLE_CLOCKING === 'True') {
                      if (t.clock_in) {
                        diff = dayjs(t.clock_out).diff(t.clock_in, 's')
                      }
                    }
                    return (
                      <tr key={i}>
                        <td>
                          <label>{t.staff?.name}</label>
                        </td>
                        <td>
                          <span>{t.staff?.email}</span>
                        </td>
                        {business?.ENABLE_CLOCKING === 'True' && (
                          <td>
                            <span>
                              {diff && <GetDuration value={diff} completed={booking.completed} />}
                            </span>
                          </td>
                        )}
                        <td className='text-end'></td>
                      </tr>
                    )
                  })}
                  {/* {booking.staff &&
                    (booking.staff_id === currentUser?.account_id ||
                      currentUser?.role_level! <= 4) && (
                      <tr>
                        <td>
                          <label className='w-150px'>{booking.staff?.name}</label>
                        </td>
                        <td>
                          <span>{booking.staff?.email}</span>
                        </td>
                        <td className='text-end'>
                          <span
                            onClick={() => declineBooking.mutate()}
                            className='btn btn-light btn-light-danger btn-sm'
                          >
                            Decline Booking
                          </span>
                        </td>
                      </tr>
                    )} */}
                </tbody>
                {/*end::Table body*/}
              </table>
              {/*end::Table*/}
            </div>
            {/*end::Product table*/}
          </div>
          {/*end::Section*/}
        </div>
        {/*end::Card body*/}
      </div>
    </>
  )
}

export {FetchModalPage}
